# Directives
clientApp = angular.module("clientApp.directives", ["ui.bootstrap.transition"])

clientApp.directive "appVersion", ["version", (version) ->
  return (scope, elm, attrs) ->
    elm.text version
]

